module.exports = __webpack_public_path__ + "static/img/manual-19.c9e0157.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-19.png
// module id = +5vh
// module chunks = 4